var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37 28c1.1 0 2 .9 2 2 0 .55-.22 1.05-.59 1.41-.36.37-.86.59-1.41.59h-2-6-2c-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41.36-.37.86-.59 1.41-.59h2 6z",
    fill: "#969faa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35 27v1h-6v-1c0-1.66 1.34-3 3-3 .83 0 1.58.34 2.12.88s.88 1.29.88 2.12z",
    fill: "#ccd1d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29 32h6v6h-6z",
    fill: "#ccd1d9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6e9ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52 56h8v6h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 10v8h-6.68c.44-1.25.68-2.6.68-4s-.24-2.75-.68-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 10h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 30h-8v-11c0-.55-.45-1-1-1h-3v-8h6c3.31 0 6 2.69 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 38h6v8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 52h-8v-6-8-4h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 46v-8h7 6 7v8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 38v8h-3c-.55 0-1 .45-1 1v5h-8v-8c0-3.31 2.69-6 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 56h8v6h-8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 53v2c0 .55-.45 1-1 1h-1-8-1c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h1 8 1c.55 0 1 .45 1 1z",
    fill: "#fcd770"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22 46v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1-8-1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1z",
    fill: "#fcd770"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m46 46v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1-8-1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1z",
    fill: "#fcd770"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m62 53v2c0 .55-.45 1-1 1h-1-8-1c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h1 8 1c.55 0 1 .45 1 1z",
    fill: "#fcd770"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m62 31v2c0 .55-.45 1-1 1h-1-8-1c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h1 8 1c.55 0 1 .45 1 1z",
    fill: "#fcd770"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m48 18v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1-8-1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1z",
    fill: "#fcd770"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m36 18v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1-8-1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1z",
    fill: "#fcd770"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m25.32 10c.44 1.25.68 2.6.68 4s-.24 2.75-.68 4c-1.65 4.66-6.09 8-11.32 8-6.63 0-12-5.37-12-12s5.37-12 12-12c5.23 0 9.67 3.34 11.32 8z",
    fill: "#e6e9ed"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m15.41 6.91 3.24 8.21c.23.58.35 1.2.35 1.83v.05c0 1.38-.56 2.63-1.46 3.54-.87.86-2.051 1.41-3.358 1.457-2.848.102-5.182-2.388-5.182-5.238 0-.502.095-.999.279-1.465l3.311-8.384c.25-.55.8-.91 1.41-.91s1.16.36 1.41.91z",
    fill: "#fcd770"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m16.324 6.497c-.413-.909-1.325-1.497-2.324-1.497s-1.911.588-2.324 1.497l-3.238 8.205c-.291.734-.438 1.507-.438 2.298 0 3.309 2.691 6 6 6s6-2.691 6-6.049c0-.757-.141-1.498-.418-2.203zm-2.324 14.503c-2.206 0-4-1.794-4-4 0-.538.1-1.064.298-1.563l3.207-8.13c.189-.378.843-.325.979-.029l3.237 8.204c.185.47.279.964.279 1.518 0 2.206-1.794 4-4 4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m63 33v-2c0-1.103-.897-2-2-2v-13c0-3.859-3.141-7-7-7h-5c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-6c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5.003c-1.963-4.693-6.6-8-11.997-8-7.168 0-13 5.832-13 13s5.832 13 13 13c5.397 0 10.034-3.307 11.997-8h5.003c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h6c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h2v10c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v2h-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5v-4h1c1.654 0 3-1.346 3-3s-1.346-3-3-3h-1c0-2.206-1.794-4-4-4s-4 1.794-4 4h-1c-1.654 0-3 1.346-3 3s1.346 3 3 3h1v4h-5c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5c-3.859 0-7 3.141-7 7v7c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v6h10v-6c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2v-4h2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h18c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h4v4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v6h10v-6c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2v-16c1.103 0 2-.897 2-2zm-49-8c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zm12.637-8c.229-.965.363-1.966.363-3s-.134-2.035-.363-3h4.363v6zm6.363 2v-10h2l.002 10zm4-2v-6h6v6zm-24 44h-6v-4h6zm2.002-6h-10.002v-2h10zm-.002-10c-1.103 0-2 .897-2 2v4h-6v-7c0-2.757 2.243-5 5-5h5v6zm17-20c1.103 0 2 .897 2 2h-4c0-1.103.897-2 2-2zm-6 5c0-.552.448-1 1-1h10c.552 0 1 .448 1 1s-.448 1-1 1h-10c-.552 0-1-.448-1-1zm4 3h4v4h-4zm-11 14v-10h2l.002 10zm4-2v-6h18v6zm22-26v-10h2l.002 10zm6-2h-2v-6h5c2.757 0 5 2.243 5 5v13h-6v-10c0-1.103-.897-2-2-2zm0 14h10l.002 2h-10.002zm-8 16v-10h2l.002 10zm4-2v-6h4v6zm12 16h-6v-4h6zm2.002-6h-10.002v-2h10zm-2.002-4h-6v-16h6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m55 47h2v2h-2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m55 43h2v2h-2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m55 39h2v2h-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m29 41h2v2h-2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m25 41h2v2h-2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m33 41h2v2h-2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m55 25h2v2h-2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m55 21h2v2h-2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m55 17h2v2h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineIcon);
export default __webpack_public_path__ + "static/media/pipeline-icon.371909360ce8c2a9e8966afe46d080e9.svg";
export { ForwardRef as ReactComponent };